import React from 'react';

const BusinessInsights = ({ insights }) => {
    // Default/Fallback Data
    const data = insights || {
        topItem: '-',
        avgBillValue: 0,
        peakTime: '-',
        newCustomers: 0,
        returningCustomers: 0
    };

    const MetricBox = ({ label, value, sub }) => (
        <div style={{ background: '#f9f9f9', borderRadius: '8px', padding: '12px', flex: 1 }}>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '4px' }}>{label}</div>
            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1F1F1F' }}>{value}</div>
            {sub && <div style={{ fontSize: '11px', color: '#666' }}>{sub}</div>}
        </div>
    );

    return (
        <div className="dashboard-card">
            <h3 style={{ margin: '0 0 20px 0', fontSize: '16px', fontWeight: 'bold', color: '#1F1F1F' }}>
                BUSINESS INSIGHTS
            </h3>

            <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                <MetricBox label="Avg Bill Value" value={`₹${Math.round(data.avgBillValue).toLocaleString()}`} />
                <MetricBox label="Peak Time" value={data.peakTime} />
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
                <MetricBox label="New Customers" value={data.newCustomers} sub="This Month" />
                <MetricBox label="Top Item" value={data.topItem} />
            </div>
        </div>
    );
};

export default BusinessInsights;
